<template>
  <v-navigation-drawer
    v-if="user"
    id="core-navigation-drawer"
    v-model="isOpen"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-divider class="mb-1" />

    <v-list dense nav>
      <v-list-item>
        <v-list-item-avatar class="align-self-center" color="white" contain>
          <a href="https://www.propcheck.com.au"><v-img src="/favicon.ico" max-height="100" /></a>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="text-h4">
            <div style="cursor: pointer;" @click="goHome()">PropCheck</div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group v-if="item.children" :key="`group-${i}`" :item="item">
        </base-item-group>

        <base-item v-else :key="`item-${i}`" :item="item" />
      </template>

      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isOpen: false,
    items: [
      {
        icon: "mdi-account-box",
        title: "user-dashboard",
        to: "/pages/user-dashboard"
      },
      {
        icon: "mdi-magnify",
        title: "search",
        to: "/"
      },
      {
        icon: "mdi-account",
        title: "user",
        to: "/pages/user"
      },
      {
        icon: "mdi-currency-usd",
        title: "subscribe",
        to: "/pages/subscribe"
      },
      {
        icon: "mdi-book",
        title: "resources",
        to: "/pages/resources"
      },
      {
        icon: "mdi-help",
        title: "contact",
        href: "https://www.propcheck.com.au/contact/"
      },      
    ],
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    user() {
      return this.$store.state.user.user;
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        title: this.$t("avatar")
      };
    }
  },
  
  mounted() {
    // Listen for toggle event from AppBar
    this.$root.$on('toggle-drawer', this.toggle);
  },
  
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('toggle-drawer', this.toggle);
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title)
      };
    }, 
    goHome(){
      window.location.href = "https://www.propcheck.com.au";
    },
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
